import { render, staticRenderFns } from "./AIChatResolvedProductCards.vue?vue&type=template&id=4c0838eb&scoped=true"
import script from "./AIChatResolvedProductCards.vue?vue&type=script&lang=js"
export * from "./AIChatResolvedProductCards.vue?vue&type=script&lang=js"
import style0 from "./AIChatResolvedProductCards.vue?vue&type=style&index=0&id=4c0838eb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0838eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c0838eb')) {
      api.createRecord('4c0838eb', component.options)
    } else {
      api.reload('4c0838eb', component.options)
    }
    module.hot.accept("./AIChatResolvedProductCards.vue?vue&type=template&id=4c0838eb&scoped=true", function () {
      api.rerender('4c0838eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatResolvedProductCards.vue"
export default component.exports